const charges = {
  getlist: 'AdsAttributionCharge/getlist',
  get: 'AdsAttributionCharge/get',
  add: 'AdsAttributionCharge/add',
  update: 'AdsAttributionCharge/update',
  remove: 'AdsAttributionCharge/remove'
}
export default charges
